import axios from 'axios';
import { BABYFACE_URL } from '../../lib/routes/Routes';
import { ERROR_RETRY } from '../../lib/Error';

export const getWorkspace = ({ id, token }) =>
  axios.get(
    BABYFACE_URL.concat(`/he/conversion/workspaces/${id}?token=${token}`),
  );

export const registerPregnant = async ({
  workspaceId, 
  pregnantAccountId, 
  token
}) => {
  try {
    const response = await axios.post(
      BABYFACE_URL.concat(`/he/conversion/workspaces/${workspaceId}/pregnant?token=${token}`),
      {
        pregnantAccountId
      },
    );
    return response.data;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};

export const consentPrivacyUsage = ({
  workspaceId, 
  name = null,
  phone = null,
  token
}) => axios.post(
  BABYFACE_URL.concat(`/he/conversion/workspaces/${workspaceId}/privacy-consent?token=${token}`),
  {
    name,
    phone
  },
);

export const postReviewEvent = ({
  workspaceId,
  url,
  screenshot,
  token
}) => {
  const formData = new FormData();
  formData.append('workspaceId', workspaceId);
  formData.append('url', url);
  formData.append('screenshot', screenshot);

  return axios.post(
    BABYFACE_URL.concat(`/he/events/review-event?token=${token}`),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
};

export const validateBarcode = ({ barcodeId }) => {
  return axios.get(
    BABYFACE_URL.concat(`/he/barcode/validate/${barcodeId}`)
  );
};